class ApiClientInterface {
    // name must be a unique method name for the request. Examples: "get_user", "post_user", "login", etc
    registerEndpoint = (name, method, path) => {
        throw new Error("registerEndpoint method not implemented")
    }
}

export default ApiClientInterface;